import RolePermissionContainer from 'containers/role/RolePermissionContainer';
import React from 'react';

const RolePermissionPage = () => {
  return <RolePermissionContainer />;
};

export default RolePermissionPage;
